<header class="topbar">
  <div>
    <p>{{ portalEyebrow }}</p>
    <h1>{{ portalTitle }}</h1>
  </div>

  <div class="actions">
    @if (isBusinessPortal) {
      <label class="location-switcher">
        <span class="material-symbols-outlined" aria-hidden="true">location_on</span>
        <select
          aria-label="Active business location"
          [ngModel]="locationContext.selectedLocationId()"
          (ngModelChange)="selectBusinessLocation($event)"
          [disabled]="isLocationsLoading || !businessLocations.length">
          @if (!businessLocations.length) {
            <option [ngValue]="null">{{ isLocationsLoading ? 'Loading locations...' : 'Create a location first' }}</option>
          }
          @for (location of businessLocations; track location.id) {
            <option [value]="location.id">{{ location.name }}{{ location.isPrimary ? ' · Primary' : '' }}</option>
          }
        </select>
      </label>
    }
    @if (!isBusinessPortal) {
      <button class="icon-button" type="button" title="Test notification" aria-label="Test notification" (click)="openNotificationTester()">
        <span class="material-symbols-outlined" aria-hidden="true">notification_add</span>
      </button>
    }
    <a class="profile" [routerLink]="profileRoute">
      <span class="avatar">{{ profileInitials }}</span>
      <span>
        <strong>{{ currentUser.user()?.name || (isBusinessPortal ? 'Business user' : 'Platform admin') }}</strong>
        <small>{{ profileRole }}</small>
      </span>
    </a>
    <button class="logout-button" type="button" (click)="logout()">
      <span class="material-symbols-outlined" aria-hidden="true">logout</span>
      Logout
    </button>
  </div>
</header>

@if (showNotificationTester) {
  <div class="modal-backdrop" (click)="closeNotificationTester()">
    <section class="notification-modal" role="dialog" aria-modal="true" aria-labelledby="notification-test-title" (click)="$event.stopPropagation()">
      <div class="modal-heading">
        <div>
          <p>Firebase delivery</p>
          <h2 id="notification-test-title">Test notification</h2>
        </div>
        <button class="close-button" type="button" title="Close" aria-label="Close" [disabled]="isSendingNotification" (click)="closeNotificationTester()">
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button>
      </div>

      @if (notificationSuccess) { <p class="modal-state success">{{ notificationSuccess }}</p> }
      @if (notificationError) { <p class="modal-state error">{{ notificationError }}</p> }

      <div class="browser-push-status">
        <span class="material-symbols-outlined" aria-hidden="true">devices</span>
        <div>
          <strong>This browser</strong>
          <small>{{ webPushStatus() }}</small>
        </div>
        <button type="button" [disabled]="webPush.status() === 'Enabling'" (click)="enableThisBrowser()">
          {{ webPush.status() === 'Enabled' ? 'Reconnect' : webPush.status() === 'Enabling' ? 'Enabling...' : 'Enable' }}
        </button>
      </div>

      <form class="notification-form" (ngSubmit)="sendTestNotification()">
        <label>
          <span>Recipient</span>
          <select name="notificationUser" [(ngModel)]="notificationForm.userId" required [disabled]="isUsersLoading">
            <option value="" disabled>{{ isUsersLoading ? 'Loading users...' : 'Select user' }}</option>
            @for (user of notificationUsers; track user.id) {
              <option [value]="user.id">{{ user.name }} - {{ user.email }}</option>
            }
          </select>
        </label>
        <label>
          <span>Notification type</span>
          <select name="notificationType" [(ngModel)]="notificationForm.type" required>
            @for (type of notificationTypes; track type.value) { <option [ngValue]="type.value">{{ type.label }}</option> }
          </select>
        </label>
        <label class="full-width">
          <span>Title</span>
          <input name="notificationTitle" [(ngModel)]="notificationForm.title" maxlength="160" placeholder="Notification title" required />
        </label>
        <label class="full-width">
          <span>Message</span>
          <textarea name="notificationMessage" [(ngModel)]="notificationForm.message" maxlength="1000" rows="4" placeholder="Message shown on the device" required></textarea>
        </label>
        <label class="full-width">
          <span>Additional data (optional JSON)</span>
          <textarea name="notificationData" [(ngModel)]="notificationForm.dataJson" rows="3" placeholder='{"productId":"..."}'></textarea>
        </label>
        <div class="modal-actions full-width">
          <button class="cancel-button" type="button" [disabled]="isSendingNotification" (click)="closeNotificationTester()">Cancel</button>
          <button class="send-button" type="submit" [disabled]="isSendingNotification || isUsersLoading">
            <span class="material-symbols-outlined" aria-hidden="true">send</span>
            {{ isSendingNotification ? 'Sending...' : 'Send test' }}
          </button>
        </div>
      </form>

      @if (webPush.receivedMessages().length) {
        <section class="received-notifications" aria-label="Received test notifications">
          <h3>Received in this browser</h3>
          @for (notification of webPush.receivedMessages(); track notification.id) {
            <article>
              <span class="material-symbols-outlined" aria-hidden="true">notifications_active</span>
              <div>
                <strong>{{ notification.title }}</strong>
                <p>{{ notification.message }}</p>
                <small>{{ notification.receivedAt.toLocaleTimeString() }}</small>
              </div>
            </article>
          }
        </section>
      }

      <section class="received-notifications" aria-label="Recent notifications">
        <h3>Recent notifications</h3>
        @if (isNotificationsLoading) {
          <p class="notification-list-state">Loading notifications...</p>
        } @else if (!savedNotifications.length) {
          <p class="notification-list-state">No notifications yet.</p>
        } @else {
          @for (notification of savedNotifications; track notification.id) {
            <article [class.unread]="!notification.isRead" (click)="markNotificationRead(notification)">
              <span class="material-symbols-outlined" aria-hidden="true">{{ notification.isRead ? 'notifications' : 'notifications_active' }}</span>
              <div>
                <strong>{{ notification.title }}</strong>
                <p>{{ notification.message }}</p>
                @if (notification.createdAt) { <small>{{ notificationDate(notification.createdAt) }}</small> }
              </div>
            </article>
          }
        }
      </section>
    </section>
  </div>
}
